export * from '@primeuix/themes/aura/inputotp';
export { default } from '@primeuix/themes/aura/inputotp';
